import React, { Component } from "react"
import { connect } from "react-redux"
import {
  changeDisplayedLanguage,
  checkIfMobileAlreadyExists,
  logScreenEnterance,
  onUserSignInClick,
  readBgServiceConfiguration,
  readStationIdFromBgService,
  reportSuspiciousBrokenLockers,
  getAllOpenedLockers,
  resetAllReducers,
} from "../../../actions"
import { validation } from "../../../utils/Validations"
import { DisEnbPendBtn, InputFiled } from "../../common"
import VirtualKeyboard from "../../common/VirtualKeyboard"
import ErrorInfoModal from "../../Modals/ErrorInfoModal"
import YesNoInfoModal from "../../Modals/YesNoInfoModal"
import "./style.scss"

class InputMobileForOTP extends Component {
  constructor(props) {
    super(props)

    this.INIT_STATE = {
      flow: {
        step1_EnterPhone: true,
      },
      mobile: "",
      mobileRef: null,
      activeInput: null,
      activeInputName: null,
      isSubmitBtnDisabled: false,
      mobileErr: false,
      errorsTimeout: null,
      showErrorModal: false,
      isPasswordResetModalShown: false,
      runValidationsTimeOut: null,
      openedDoorModalCloseClicked: false,
      showPhoneNotFoundModal: false,
      showBaseErrorModal: false,
      inputPasswordType: "password",
      //   serviceName: "",
    }

    this.state = this.INIT_STATE
    this.mobileInput = React.createRef()
  }

  componentDidMount() {
    this.setState(this.INIT_STATE)

    this.props.resetAllReducers()
    this.props.readStationIdFromBgService()

    this.props.readBgServiceConfiguration()
    const { maxLockerNumber, brokenLockersNumArr } = this.props
    this.props.getAllOpenedLockers(maxLockerNumber, brokenLockersNumArr)

    this.runValidations()
    // this.setState({ serviceName: this.props.history.location.state })
    this.props.logScreenEnterance("USER_LOGIN_WITH_DONE_LOGIN")
  }

  componentWillUnmount() {
    let { runValidationsTimeOut, errorsTimeout } = this.state
    if (runValidationsTimeOut) {
      clearTimeout(runValidationsTimeOut)
    }
    if (errorsTimeout) {
      clearTimeout(errorsTimeout)
    }
    this.setState(this.INIT_STATE)
  }

  componentWillReceiveProps(newProps) {
    const { errTitle, errText, isError } = newProps

    this.setState({ showBaseErrorModal: isError })

    if (
      this.state.flow.step1_EnterPhone &&
      newProps.mobileChecked &&
      !newProps.userMobileFree
    ) {
      let flow = this.state.flow
      flow.step1_EnterPhone = false
      this.setState({ flow })
    }

    if (
      this.state.flow.step1_EnterPhone &&
      newProps.mobileChecked &&
      newProps.userMobileFree
    ) {
      this.setState({ showPhoneNotFoundModal: true })
    }

    if (this.state.flow.step1_EnterPhone) {
      this.setState({
        activeInput: this.state.mobileRef,
        activeInputName: "mobile",
      })
    }

    const { errTitle: oldErrTitle, errText: oldErrText } = this.props

    if (oldErrTitle !== errTitle || oldErrText !== errText) {
      setTimeout(
        () =>
          this.setState({
            showErrorModal: true,
          }),
        250
      )
    }
  }

  onKeyboardTextChange(text) {
    const { activeInputName, errorsTimeout } = this.state

    if (errorsTimeout) {
      clearTimeout(errorsTimeout)
    }

    this.setState({
      [activeInputName]: text,
      mobileErr: false,
      errorsTimeout: null,
    })

    this.runValidationsWithTimoutDebounce()
  }

  onRefReady(refName, ref) {
    if (!this.state[refName]) this.setState({ [refName]: ref })
  }

  onInputFocusChange(refName, isFocused) {
    if (isFocused) {
      this.setState({
        activeInput: this.state[refName],
        activeInputName: refName.replace("Ref", ""),
      })
    } else {
      if (this.state.activeInput === this.state[refName])
        this.setState({ activeInput: null })
    }
  }

  runValidations() {
    const { mobile } = this.state

    const isMobileNumValid = validation.Mobile05(mobile)

    const isEmptyMobile = mobile.length < 1

    const isSubmitBtnDisabled = !isMobileNumValid
    const isSubmitMobileBtnDisabled = !isMobileNumValid || isEmptyMobile
    const mobileErr = !isMobileNumValid && !isEmptyMobile

    if (!isSubmitBtnDisabled) {
      this.setState({
        isSubmitBtnDisabled,
        mobileErr,
        runValidationsTimeOut: null,
      })
    } else {
      const errorsTimeout = setTimeout(
        () =>
          this.setState({
            isSubmitBtnDisabled,
            mobileErr,
            runValidationsTimeOut: null,
          }),
        800
      )

      this.setState({ errorsTimeout })
    }

    if (!isSubmitMobileBtnDisabled) {
      this.setState({
        isSubmitMobileBtnDisabled,
        mobileErr,
        runValidationsTimeOut: null,
      })
    } else {
      const errorsTimeout = setTimeout(
        () =>
          this.setState({
            isSubmitMobileBtnDisabled,
            mobileErr,
            runValidationsTimeOut: null,
          }),
        800
      )

      this.setState({ errorsTimeout })
    }
  }

  onViewPasswordClick() {
    const { inputPasswordType } = this.state
    if (inputPasswordType === "password") {
      this.setState({ inputPasswordType: "text" })
    } else {
      this.setState({ inputPasswordType: "password" })
    }
  }

  onInputFieldChange(inputName, val, evt) {
    evt.persist()
    this.setState({ [inputName]: val })
    this.runValidationsWithTimoutDebounce(inputName, val)
  }

  runValidationsWithTimoutDebounce() {
    let { runValidationsTimeOut } = this.state

    if (runValidationsTimeOut) {
      clearTimeout(runValidationsTimeOut)
    }

    runValidationsTimeOut = setTimeout(() => this.runValidations(), 500)

    this.setState({ runValidationsTimeOut })
  }

  filterEnterAndSubmit(e) {
    e.persist()
    if (e.key === "Enter") {
      setTimeout(() => {
        const { isSubmitBtnDisabled } = this.state

        if (!isSubmitBtnDisabled) {
          this.onSignInClick()
        }
      }, 700)
    }
  }

  onLangChange(lang) {
    this.props.changeDisplayedLanguage(lang)
  }

  render() {
    const {
      mobile,
      activeInputName,
      isSubmitMobileBtnDisabled,
      mobileErr,
      showPhoneNotFoundModal,
      showErrorModal,
      showBaseErrorModal,
      inputPasswordType,
    } = this.state

    const {
      errTitle,
      errText,
      isLoadingRequest,
      dirRtl,
      cellphone_input_text_hint,
      continue_text,
      close_text,
      input_phone_title,
      validationtext,
      phone_number_not_found,
      create_new_user_btn_text,
      base_error_title,
      base_error_text,
    } = this.props

    const phone_number_not_found_text = phone_number_not_found.replace(
      "{mobile}",
      mobile
    )

    const { step1_EnterPhone } = this.state.flow

    let subTitle = input_phone_title
    let extraClass = " step1_EnterPhone"
    // //"ls-wrapper lundry-login"
    return (
      <div className={"lundry-login" + extraClass}>
        <div className="input-mobile-otp-wrapper">
          <InputFiled
            show={true}
            value={mobile}
            onChange={(e) =>
              this.onInputFieldChange("mobile", e.target.value, e)
            }
            placeholder={cellphone_input_text_hint}
            icon="mini_phone"
            onRefReady={(ref) => this.onRefReady("mobileRef", ref)}
            onFocusChanged={(isFocused) =>
              this.onInputFocusChange("mobileRef", isFocused)
            }
            displayErr={mobileErr}
            onKeyPress={(e) => this.filterEnterAndSubmit(e)}
            mandatory
            maxLength={10}
            type="tel"
            disabled={!step1_EnterPhone}
            isvalid={this.state.isMobileNumValid}
            validationtext={validationtext.mobile}
            autoFocus
          />
          <DisEnbPendBtn
            show={step1_EnterPhone}
            onClick={() => this.props.onClick(mobile)}
            isDisabled={isSubmitMobileBtnDisabled}
            isPending={isLoadingRequest}
            extraClass="login-btn"
          >
            {continue_text}
          </DisEnbPendBtn>
        </div>
        <VirtualKeyboard
          currentValue={this.state[activeInputName]}
          onKeyboardInputChange={(txt) => this.onKeyboardTextChange(txt)}
          show={true}
          lang={activeInputName === "mobile" ? "mobile" : "en"}
          closeOnEnter
          blockLangSwitch={inputPasswordType}
          otpScreen
        />
        <ErrorInfoModal
          dirRtl={dirRtl}
          show={showErrorModal && errTitle && errText}
          title={errTitle}
          text={errText}
          onModalCloseClick={() => this.setState({ showErrorModal: false })}
          closeTrnsl={close_text}
        />

        <ErrorInfoModal
          dirRtl={dirRtl}
          show={showBaseErrorModal}
          title={base_error_title}
          text={base_error_text}
          onModalCloseClick={() => this.setState({ showBaseErrorModal: false })}
          closeTrnsl={close_text}
        />

        <YesNoInfoModal
          show={showPhoneNotFoundModal}
          title={""}
          text={phone_number_not_found_text}
          onModalOkClick={(e) => this.props.history.push("SignUpStep1Screen")}
          onModalCancelClick={(e) =>
            this.setState({ showPhoneNotFoundModal: false })
          }
          okTransl={create_new_user_btn_text}
          cancelTransl={close_text}
          dirRtl={this.props.dirRtl}
        />
        {/* <FixedFooter history={history} /> */}
      </div>
    )
  }
}

const mapStateToProps = ({
  userLogin,
  bgService,
  translate,
  stationServiceTypes,
  registration,
  lockersCells,
}) => {
  const { stationId } = bgService

  const { maxLockerNumber, brokenLockersNumArr } = lockersCells
  const {
    authenticated,
    errTitle,
    errText,
    isLoadingRequest,
    isPasswordTemporary,
    isRefillDetails,
    userId,
    isError,
  } = userLogin
  const {
    dirRtl,
    langName,
    welcome_title_text,
    cellphone_input_text_hint,
    register_btn_text,
    password_input_text_hint,
    continue_text,
    password_for_delivery,
    pick_const_pwd_msg_title,
    pick_const_pwd_msg_body,
    close_text,
    back_btn_text,
    system_updgrade_err_msg,
    login_laundry,
    input_phone_title,
    validation_empty_text,
    validation_mobile_text,
    validation_password_text,
    validation_name_text,
    validation_email_text,
    validation_email_verification_text,
    input_psw_title,
    input_temp_psw_title,
    phone_number_not_found,
    create_new_user_btn_text,
    base_error_title,
    base_error_text,
    password_login_button_title,
  } = translate

  let validationtext = {
    empty: validation_empty_text,
    mobile: validation_mobile_text,
    password: validation_password_text,
    name: validation_name_text,
    email: validation_email_text,
    emailVerification: validation_email_verification_text,
  }

  const { isDeliverySimulationStation } = stationServiceTypes
  const { mobileChecked, userMobileFree } = registration
  return {
    authenticated,
    errTitle: translate[errTitle],
    errText: translate[errText],
    isLoadingRequest,
    isPasswordTemporary,
    userId,
    stationId,
    isError,
    dirRtl,
    langName,
    maxLockerNumber,
    brokenLockersNumArr,
    welcome_title_text,
    cellphone_input_text_hint,
    password_input_text_hint,
    continue_text,
    password_for_delivery,
    register_btn_text,
    pick_const_pwd_msg_title,
    pick_const_pwd_msg_body,
    back_btn_text,
    close_text,
    system_updgrade_err_msg,
    login_laundry,
    input_phone_title,
    validationtext,
    input_psw_title,
    input_temp_psw_title,
    phone_number_not_found,
    create_new_user_btn_text,
    base_error_title,
    base_error_text,
    isDeliverySimulationStation,
    mobileChecked,
    userMobileFree,
    isRefillDetails,
    password_login_button_title,
  }
}

export default connect(mapStateToProps, {
  onUserSignInClick,
  readStationIdFromBgService,
  readBgServiceConfiguration,
  resetAllReducers,
  getAllOpenedLockers,
  changeDisplayedLanguage,
  reportSuspiciousBrokenLockers,
  logScreenEnterance,
  checkIfMobileAlreadyExists,
})(InputMobileForOTP)
